import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { ToastContainer } from 'react-toastify';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

import Register from 'components/Auth/Register';
import Login from 'components/Auth/Login';
import UpdateGroup from 'components/group/UpdateGroup';
import GroupsList from 'components/group/GroupsList';
import OpportunitiesList from 'components/OpportunitiesList';
import ApolloProvider from 'apollo/Provider';
import config, { clients } from 'config';

import 'react-toastify/dist/ReactToastify.css';
import './App.scss';

export const ThemeContext = React.createContext();

setupLogRocketReact(LogRocket);

class App extends Component {
  constructor() {
    super();

    let clientId = '';
    const params = window.location.search;
    if (params.includes('?clientId=')) {
      clientId = params.split('=').pop();
      console.log('constructor clientId: ', clientId);
      localStorage.setItem('clientId', clientId);
    }

    this.state = {
      theme: clients.default,
    }

    // LogRocket
    if (config.LOGROCKET_KEY) {
      LogRocket.init(config.LOGROCKET_KEY, {
        release: process.env.LOGROCKET_RELEASE,
      });
    }
  }

  componentDidMount() {
    const clientId = localStorage.getItem('clientId');
    console.log('CDM: ', clientId);

    if (clientId) {
      const configURL = `${config.DATA_URL}/${clientId}/management-config.json`;
      console.log('configURL: ', configURL);
      fetch(configURL)
        .then(response => response.json())
        .then((settings) => {
          console.log('settings: ', settings);
          this.setState({
            theme: {
              ...clients.default,
              ...settings,
            },
          });
        })
        .catch((error) => {
          // TODO: we don't seem to get 404. Only error message; thus below doesn't work.
          if (error.status === 404) {
            this.setState({ error: new Error('Got a 404 while loading config (is a backend configured for this client gateway page?)') });
          }
          this.setState({ error });
        });
    }
    else {
      console.log('ELSE');
      this.setState({ loading: false });
    }
  }

  render() {
    const { theme } = this.state;

    // TODO: REMOVE!!
    console.log('== Env: ', process.env.REACT_APP_ENV);
    console.log('== Theme: ', theme);

    return (
      <ApolloProvider>
        <Router basename="management-portal">
          {/*
            ThemeContext is for general purpose.
            We pass this down if for some reason we're not using styled-components
            to style a specific component.
            Eg. we want to know the brand primary/secondary color but we don't need it
            for CSS classes but for another purpose.
            Eg. <Icon /> needs to know the primary color, so that it can fill and SVG with
            that color.
          */}
          <ThemeContext.Provider value={theme}>
            {/* ThemeProvider is for styled-components */}
            <ThemeProvider theme={theme}>
              <div className="App">
                <Route path="/" exact component={GroupsList} />
                <Route path="/register" component={Register} />
                <Route path="/login" component={Login} />
                <Route path="/update-group/:id" component={UpdateGroup} />
                <Route path="/group/:id/opportunities" component={OpportunitiesList} />
                <ToastContainer />
              </div>
            </ThemeProvider>
          </ThemeContext.Provider>
        </Router>
      </ApolloProvider>
    );
  }
};

export default App;
